global.renderValue = function (value, selector = "#coverage__value") {
  document.querySelectorAll(selector).forEach((el) => (el.textContent = value));
};

